import React, { FC, useState } from 'react';
import { Popover } from '@mui/material';
import clsx from 'clsx';
import Button from '@/components/ui/Button';

interface IProps {
  period: string | null;
  onApply: (period: string | null) => void;
}

const periodOptions = [
  { label: 'Today', value: 'today' },
  { label: 'This week', value: 'this-week' },
  { label: 'This month', value: 'this-month' },
  { label: 'Last 3 months', value: 'last-3-months' },
];

const PeriodFilter: FC<IProps> = ({ period, onApply }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const [tempPeriod, setTempPeriod] = useState(period);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleApply = () => {
    onApply(tempPeriod);
    handleClose();
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <div
        className="relative h-10 w-full"
        role="presentation"
        onClick={handleClick}
      >
        <input
          readOnly
          className={clsx(
            'w-full h-full cursor-pointer rounded border bg-white px-3 py-2 text-body2 placeholder:text-primary placeholder:font-bold',
            'border-grey-300 outline-primary',
            'focus:outline-1'
          )}
          placeholder="Filter by period"
          value=""
        />
        <i
          className={clsx(
            'pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[20px] text-primary',
            open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'
          )}
        />
      </div>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={open}
        PaperProps={{
          className:
            'shadow-[0px_0px_20px_-4px_rgba(64,64,64,0.20)] rounded-lg',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handleClose}
      >
        <div className="w-[240px] py-2">
          <div className="flex flex-col">
            {periodOptions.map((opt) => (
              <div
                key={opt.value}
                className="flex h-9 cursor-pointer items-center justify-between px-3 py-2 hover:bg-navy-50"
                role="presentation"
                onClick={() => setTempPeriod(opt.value)}
              >
                <span
                  className={clsx(
                    'text-body2',
                    tempPeriod === opt.value ? 'text-grey-400' : 'text-navy-700'
                  )}
                >
                  {opt.label}
                </span>
                <i
                  className={clsx(
                    'ri-check-line text-green-400',
                    tempPeriod === opt.value ? 'visible' : 'invisible'
                  )}
                  style={{ fontSize: '20px' }}
                />
              </div>
            ))}
          </div>
          <div className="border-t border-grey-200 px-3 pb-2 pt-3">
            <Button
              className="w-full"
              label="Apply filter"
              size="small"
              variant="success"
              onClick={handleApply}
            />
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default PeriodFilter;
